import _ from 'lodash';

const serviceGroupHasService = (serviceGroup, serviceId) =>
  _.findIndex(serviceGroup?.services, (service: any) => service.service_id === serviceId) >= 0;

export default serviceGroupHasService;
